/**
 * 任务调度设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerApplyManageService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   constructor(
     private http: SwHttpClientService
   ) {
   }

  //#region scheduleTask 产品设置接口


  /**
   * 查询平台用户申请列表
   * @param param
   * @returns {Observable<any>}
   */
  getCustomerApplyList(param) {
    const url = this.prefix+'authCustomer/queryPageList';
    return this.http.Post(url, param);
  }


  /**
   * 查看平台用户申请
   *
   * @param param
   */
  getCustomerApplyInfo(param) {
    const url = this.prefix + 'customerApply/queryById';
    return this.http.Post(url, param);
  }

    /**
   * 查看平台用户申请
   *
   * @param param
   */
  getCustomerUserInfo(param) {
    const url = this.prefix + 'customerUser/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 添加平台用户申请
   *
   * @param param
   */
  saveCustomerApply(param) {
    const url = this.prefix + 'customerApply/save';
    return this.http.Post(url, param);
  }


  /***
   * 审批平台用户申请
   *
   * @param param
   */
  approveCustomerApply(param) {
    const url = this.prefix+'authCustomer/approve';
    return this.http.Post(url, param);
  }


  //#endregion

}
